
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/obmen-i-vozvrat",
      function () {
        return require("private-next-pages/obmen-i-vozvrat.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/obmen-i-vozvrat"])
      });
    }
  